$.fn.serializeObject = function serializeObject() {
  const obj = {};
  
  $.each(this.serializeArray(), (i, o) => {
    const n = o.name;
    const v = o.value;
  
    /* eslint-disable no-nested-ternary */
    obj[n] = obj[n] === undefined ? v
      : $.isArray(obj[n]) ? obj[n].concat(v)
        : [obj[n], v];
    /* eslint-enable no-nested-ternary */
  });
  
  return obj;
};
